import { Component, OnInit } from '@angular/core';
import { environment as configs } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { HttpClient, HttpParams, HttpEventType, HttpResponse, HttpRequest, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router'
import { CommonService } from "../common.service"
import { NzModalService } from 'ng-zorro-antd';
declare var Swal;
declare var $;
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

   constructor(private fb: FormBuilder, private httpClient: HttpClient, private router: Router, private CSF: CommonService, private modalService: NzModalService) {
    this.CSF.setBusyStatus(false)
    this.CSF.setNavs(false);
  }

  host = configs['ApiHost'];
  assestBase = configs['Assetbase'];
  username=""
  mobile=""
  newpass=''
  confirmpass=''
  isUserFound=false;
  userdata:any={mobile:''};
  otp='';

  ngOnInit() {
  }


  findUser(){
  	//alert(this.username)
  	if(this.username!=undefined && this.username.length>0 ){
  		 	this.CSF.toggleBusy();
      		this.httpClient.post(this.host + '/forgot/password', {UsName:this.username}, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).subscribe(resp => {
        		this.CSF.toggleBusy();
        		if(resp['status']==true){
        			this.isUserFound=true;
        			this.userdata=resp['data']
        		}else{
        			this.isUserFound=false;
        		}
        	});
  	}
  }

  sendOTP(){
  	//alert(this.username)
  	if(this.mobile!=undefined && this.mobile.length==10 ){
  		 	this.CSF.toggleBusy();
      		this.httpClient.post(this.host + '/forgot/sendotp', {usMob:this.mobile}, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).subscribe(resp => {
        		this.CSF.toggleBusy();
        		if(resp['status']==true){
        			$('#changePassword').modal('show');
        		}else{
        			this.isUserFound=false;
        		}
        	});
  	}
  }

changePassword(){
	if(this.otp!=undefined && this.otp.length==6){
  		 	this.CSF.toggleBusy();
      		this.httpClient.post(this.host + '/forgot/changepassword', {otp:this.otp,newpass:this.newpass,confirmpass:this.confirmpass}, { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).subscribe(resp => {
        		this.CSF.toggleBusy();
        		if(resp['status']==true){
        			this.router.navigate(['login']);
        		}else{
        			this.isUserFound=false;
        		}
        	});
  	}
}


/*9417391301
otp
newpass
confirmpass

	app.post(vDir + '/forgot/password',(req,res,next)=>{ req.authrole=['public'];next();}, paymentController.getUserByUsername);
    app.post(vDir + '/forgot/sendotp',(req,res,next)=>{ req.authrole=['public'];next();}, paymentController.sendOTPforPassword);
    app.post(vDir + '/forgot/changepassword',(req,res,next)=>{ req.authrole=['public'];next();}, paymentController.checkOTP, paymentController.changePassword);

*/
}
